module.exports = __webpack_public_path__ + "static/media/sign.a804deba.svg";